import type { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import { parseEntityRef } from '@backstage/catalog-model';
import { useDomainEntities } from '../../hooks/useDomainEntities';
import { useResetOnParentChange } from '../../hooks/useResetOnParentChange';
import { readSiblingFormData } from '../formContext';
import { EntityRefAutocomplete } from '../EntityRefAutocomplete';
import type {
  DomainPickerUiOptions,
  DomainPickerValue,
} from '../../schemas/domainPickerSchema';

export const DomainPickerField = (
  props: FieldExtensionComponentProps<DomainPickerValue, DomainPickerUiOptions>,
) => {
  const {
    formData,
    onChange,
    schema,
    required,
    rawErrors,
    idSchema,
    uiSchema,
  } = props;

  const tenantFieldName = uiSchema?.['ui:options']?.tenantField ?? 'tenant';
  const tenantRefString = readSiblingFormData(props, tenantFieldName) as
    | string
    | undefined;
  const tenantRef = tenantRefString
    ? parseEntityRef(tenantRefString, { defaultKind: 'Tenant' })
    : undefined;

  const { items, loading, error } = useDomainEntities(tenantRef);
  useResetOnParentChange(tenantRefString, onChange);

  return (
    <EntityRefAutocomplete
      title={schema.title ?? 'Domain'}
      description={schema.description}
      required={required}
      rawErrors={rawErrors}
      fieldId={idSchema?.$id}
      value={formData}
      onChange={onChange}
      items={items}
      loading={loading}
      error={error}
      loadingText="Loading domains..."
      errorText="Unable to load Domains from the Catalog."
    />
  );
};
